import React, { ReactElement, ReactNode } from "react";
import { Classes } from "@components/shared/form";
import { affiliateOfferZones } from "@lib/shared/config";
import CompactOffer from "@components/shared/compactOffer";
import ThankYou from "@components/shared/thankyou";
import styles from "@components/shared/form/styles.module.scss";
import { DomainForm } from "src/api";

interface InlineThankYouStepProps {
    formSubmitted: boolean | undefined;
    goToThankYouPage: boolean | undefined;
    goToListPage: boolean | undefined;
    compactOfferBlock: unknown;
    hideOffers: boolean | undefined;
    customThankYouStep: ReactNode | undefined;
    classes?: Classes;
    form?: DomainForm;
}

export default function InlineThankYouStep({
    formSubmitted,
    goToThankYouPage,
    goToListPage,
    compactOfferBlock,
    hideOffers,
    customThankYouStep,
    classes,
    form,
}: InlineThankYouStepProps): ReactElement {
    return (
        <div className={styles["step"]}>
            <div>
                {/* thank you step */}
                <div className={styles["extra-step-inner"]}>
                    {formSubmitted && !goToThankYouPage && !goToListPage && (
                        <>
                            {compactOfferBlock && !hideOffers && (
                                <CompactOffer
                                    zone={affiliateOfferZones.THANK_YOU}
                                    classes={{}}
                                    showAllOffers
                                />
                            )}

                            {customThankYouStep ?? (
                                <ThankYou
                                    inForm={true}
                                    className={classes?.innerThankYouClassName}
                                    form={form}
                                />
                            )}
                        </>
                    )}
                </div>
                {/* thank you step */}
            </div>
        </div>
    );
}
